module.exports = __webpack_public_path__ + "static/media/clientPhoto4.9200513e.png";